import React from "react";
import { AuthPaymentContainer } from "../misc/auth-payment-container.component";
import { AuthRestartButton } from "../misc/restart-button.component";
import { usd } from "../../../utils/utils";
import moment from "moment";
import Show from "../../../utils/show.component";
import { generateLoanDescription } from "../misc/messaging-utils";

export const AuthRecurringCancellationSummary = (props) => {
  const today = moment().format("MM/DD/YYYY");
  const description = generateLoanDescription(props.selectedLoan);
  const lastFour = props.paymentResponse.LoanNumberLastFour;
  const nextDueDate = moment(props.paymentResponse.NextDueDate).format("MM/DD/YYYY");
  const regularPaymentAmount = usd.format(props.selectedLoan.RegularPaymentAmount);

  const subtitles = [
    `Your AutoPay has been cancelled today ${today} for your ${description} ending in ${lastFour}.`,
    `Your next payment of ${regularPaymentAmount} is due on ${nextDueDate}.`,
  ];

  return (
    <div>
      <AuthPaymentContainer title="AutoPay Cancelled" subtitle={""} hide={false}>
        <div className="mb-3">{subtitles[0]}</div>
        <Show condition={props.selectedLoan.IsOpenEndedLoan !== true}>
          <div className="mb-5">{subtitles[1]}</div>
        </Show>
        <AuthRestartButton
          backToLoans={props.backToLoans}
          bgColor={"#00558c"}
          margins={"m-auto"}
        />
      </AuthPaymentContainer>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/summary/auth-recurring-cancellation-summary.component.js